(function () {
  const send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", function () {
      $("#review-terms").click(function () {
        if ($(this).is(":checked")) {
          $(".cart--modal-trigger, .cart--checkout-button").removeClass(
            "qty-disable",
          );
          $(".cart--terms-more").show();
          $(".checkmark").addClass("check");
        } else {
          $(".cart--modal-trigger, .cart--checkout-button").addClass(
            "qty-disable",
          );
          $(".cart--terms-more").hide();
          $(".checkmark").removeClass("check");
        }
      });
      $(".cart--checkout-default-btn").click(function () {
        $("#termsModal").insertAfter("#loginModal");
        $("#termsModal").show();
      });

      $(".cart--modal-close").click(function () {
        $("#termsModal, .modal-backdrop").hide();
      });
    });
    return send.apply(this, arguments);
  };
})();
